// extracted by mini-css-extract-plugin
export default {"bimOtherTable":"BimWorkOrderOthersVersionPrice_bimOtherTable__Z0RC2"};